import React from "react";
import { MenuItem, Tag } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";

class SingleIDSelectWrapper extends React.Component {
  state = {
    selectedItem: null,
  };
  renderItem = (item, { handleClick, modifiers, query }) => {
    if (!modifiers.matchesPredicate) {
      return null;
    }
    let label = null;

    return (
      <MenuItem
        className="axis"
        active={modifiers.active}
        disabled={modifiers.disabled}
        onClick={handleClick}
        text={this.highlightText(item[this.props.labelKey], query)}
        shouldDismissPopover={false}
        label={label}
      />
    );
  };
  escapeRegExpChars = (text) => {
    return text.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
  };
  highlightText = (text, query) => {
    let lastIndex = 0;
    const words = query
      .split(/\s+/)
      .filter((word) => word.length > 0)
      .map(this.escapeRegExpChars);
    if (words.length === 0) {
      return [text];
    }
    const regexp = new RegExp(words.join("|"), "gi");
    const tokens = [];
    while (true) {
      const match = regexp.exec(text);
      if (!match) {
        break;
      }
      const length = match[0].length;
      const before = text.slice(lastIndex, regexp.lastIndex - length);
      if (before.length > 0) {
        tokens.push(before);
      }
      lastIndex = regexp.lastIndex;
      tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
    }
    const rest = text.slice(lastIndex);
    if (rest.length > 0) {
      tokens.push(rest);
    }
    return tokens;
  };
  handleItemSelect = (item) => {
    this.props.onChange(item);
    this.setState({ selectedItem: item });
  };
  filterItem = (query, item) => {
    /** Implement Any Random Search Here which returns a Boolean */
    /** Correspondingly IF you want aesthetics, change `highlightText` */
    const normalizedQuery = query.toLowerCase();
    const normalizedItem = item[this.props.labelKey].toLowerCase();
    return `${normalizedItem}`.indexOf(normalizedQuery) >= 0;
  };

  render() {
    if (!this.props.items || !this.props.items.length) {
      return <Tag minimal>No Items To Search</Tag>;
    }
    let inputProps = {};
    if (this.props.placeholder) {
      inputProps["placeholder"] = this.props.placeholder;
    }
    if (this.props.width) {
      inputProps["style"] = { width: this.props.width };
    }
    if (this.props.fill) {
      inputProps["fill"] = true;
    }
    if (this.props.disabled) {
      inputProps["disabled"] = true;
    }

    return (
      <Suggest
        className="axis"
        disabled={this.props.disabled}
        inputProps={inputProps}
        itemPredicate={this.filterItem}
        items={this.props.items}
        noResults={
          <MenuItem disabled={true} text="No results." className="axia" />
        }
        itemRenderer={this.renderItem}
        selectedItem={
          this.props.showSelectProp
            ? this.props.selectedItem
            : this.props.selectedItem || this.state.selectedItem || null
        }
        onItemSelect={this.handleItemSelect}
        inputValueRenderer={(item) => item[this.props.labelKey]}
        popoverProps={{ minimal: true }}
      />
    );
  }
}

export default SingleIDSelectWrapper;
